<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M7.667 5.334C6.747 5.334 6 6.08 6 7.001v14.833c0 .92.747 1.667 1.667 1.667h20c.92 0 1.667-.747 1.667-1.667V7.001c0-.92-.747-1.667-1.667-1.667h-20zm.333 2v3.333h19.334V7.334H8zm0 14.167v-7.167h19.334v7.167H8z" clip-rule="evenodd"/><path d="M2.667 25.5a1 1 0 00.679.948 1 1 0 00.487.127h13.834a1 1 0 100-2h-13V11.667a1 1 0 10-2 0v13.834z"/></svg>
</template>

<script>
export default {
  name: 'financeCreditCardsOutline'
}
</script>
